import { useEffect, useRef } from 'react';

function DualScrollTable({ children }) {
  const topScrollRef = useRef(null);
  const tableWrapperRef = useRef(null);

useEffect(() => {
  const topScroll = topScrollRef.current;
  const tableWrapper = tableWrapperRef.current;
  if (!topScroll || !tableWrapper) return;

  const syncWidth = () => {
    const table = tableWrapper.querySelector('.gi-grid-table');
    if (table && topScroll.firstChild) {
      topScroll.firstChild.style.width = table.offsetWidth + 'px';
    }
  };

  let isSyncing = false;

  const handleTopScroll = () => {
    if (isSyncing) return;
    isSyncing = true;
    tableWrapper.scrollLeft = topScroll.scrollLeft;
    isSyncing = false;
  };

  const handleBottomScroll = () => {
    if (isSyncing) return;
    isSyncing = true;
    topScroll.scrollLeft = tableWrapper.scrollLeft;
    isSyncing = false;
  };

  syncWidth();

  topScroll.addEventListener('scroll', handleTopScroll, { passive: true });
  tableWrapper.addEventListener('scroll', handleBottomScroll, { passive: true });
  window.addEventListener('resize', syncWidth);

  // ✅ 테이블 크기 변화는 ResizeObserver 가 알아서 감지
  //    → children 의존성 불필요
  const resizeObserver = new ResizeObserver(syncWidth);
  resizeObserver.observe(tableWrapper);

  return () => {
    topScroll.removeEventListener('scroll', handleTopScroll);
    tableWrapper.removeEventListener('scroll', handleBottomScroll);
    window.removeEventListener('resize', syncWidth);
    resizeObserver.disconnect();
  };
}, []);
  return (
    <div className="dual-scroll-container">
      {/* 상단 스크롤바 - 모든 스타일은 CSS에서 */}
      <div ref={topScrollRef} className="top-scroll">
        <div className="top-scroll-inner" />
      </div>

      {/* 테이블 영역 - 모든 스타일은 CSS에서 */}
      <div ref={tableWrapperRef} className="gi-grid-table-wrapper">
        {children}
      </div>
    </div>
  );
}

export default DualScrollTable;